import { Field } from "@/components/ui/Field"
import { TextField } from "@/components/ui/TextField"
import { InputMask as IM, Replacement } from "@react-input/mask"
import { InputHTMLAttributes } from "react"
import { Path, UseFormRegister } from "react-hook-form"

/** Labelled, masked react-hook-form input: Field around a TextField driven by @react-input/mask. */
export default function InputMask<T extends Record<string, unknown>>({
  name,
  label,
  error,
  errorMsg,
  registerAction,
  mask,
  replacement,
  required,
  ...props
}: Omit<InputHTMLAttributes<HTMLInputElement>, "name" | "size" | "prefix"> & {
  name: string
  label: string
  error: boolean
  errorMsg: string
  registerAction: UseFormRegister<T>
  mask: string
  replacement: Replacement
  /** Marks the label with *. Defaults to true when errorMsg is provided. */
  required?: boolean
}) {
  const isRequired = required ?? Boolean(errorMsg)

  return (
    <Field id={name + label} label={label} required={isRequired} invalid={error} error={error ? errorMsg : undefined}>
      <IM
        {...registerAction(name as Path<T>, { required: isRequired })}
        {...props}
        component={TextField}
        invalid={error}
        required={isRequired}
        mask={mask}
        replacement={replacement}
      />
    </Field>
  )
}
